// 全局模态弹窗服务
class ModalService {
  // 显示模态弹窗
  static showModal(options) {
    return new Promise((resolve) => {
      // 添加 resolve 回调到选项中
      const extendedOptions = {
        ...options,
        onConfirm: () => resolve(true),
        onCancel: () => resolve(false),
        onClose: () => resolve(false)
      };
      
      // 创建自定义事件并派发
      const event = new CustomEvent('show-global-modal', {
        detail: extendedOptions
      });
      window.dispatchEvent(event);
    });
  }
  
  // 显示提示消息（toast模式）
  static showToast(message, duration = 3000) {
    return this.showModal({
      message: message,
      type: 'toast',
      duration: duration,
      showHeader: false,
      showFooter: false
    });
  }
  
  // 显示确认对话框
  static showConfirm(title, message) {
    return this.showModal({
      title: title,
      message: message,
      type: 'modal',
      showHeader: true,
      showFooter: true
    });
  }
  
  // 显示信息对话框
  static showInfo(title, message) {
    return this.showModal({
      title: title,
      message: message,
      type: 'modal',
      showHeader: true,
      showFooter: true
    });
  }
  
  // 显示错误对话框
  static showError(title, message) {
    return this.showModal({
      title: title,
      message: message,
      type: 'modal',
      showHeader: true,
      showFooter: true
    });
  }
  
  // 显示成功对话框
  static showSuccess(title, message) {
    return this.showModal({
      title: title,
      message: message,
      type: 'modal',
      showHeader: true,
      showFooter: true
    });
  }
  
  // 显示警告对话框
  static showWarning(title, message) {
    return this.showModal({
      title: title,
      message: message,
      type: 'modal',
      showHeader: true,
      showFooter: true
    });
  }
  
  // 显示自定义模态弹窗
  static showCustom(options) {
    return this.showModal(options);
  }
}

export default ModalService;
